
import { Field } from "formik";
import React from "react";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";

const EnquirySeven = ({ setFieldValue, errors, touched, values }) => {
  return (
    <div>
      <div className="account-created-pop">
        <h3>Tell us a little more</h3>


        {/* Do you have an estimated budget? */}
        <div>
          <label>Do you have an estimated budget?</label>
          <div className="register-form-set cmn-form-set">


            <InputGroup className="ad-pound-sign">
              <InputGroup.Text>£</InputGroup.Text>
              <Field
                type="number"
                className="w-100"
                name="estimatedBudget"
                placeholder="0.00"
                min="0"
                max="200000"
              />
            </InputGroup>
         </div>
        </div>

      </div>
      {touched.estimatedBudget && errors.estimatedBudget && (
        <div className="error-message">{errors.estimatedBudget}</div>
      )}
    </div>
  );
};

export default EnquirySeven;

